import React, { useEffect, useState } from 'react'
import { Accordion, AccordionItem } from '../candidates/components/Accordion'
import UIButton from '../../components/UI/UIButton'
import UISwitch from '../../components/UI/UISwitch'
import UITextInput from '../../components/UI/UITextInput'
import {
  getAllNotificationSettings,
  UpdateNotificationsSettings,
} from '../../api/settings.tsx/settings'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { ErrorResponse } from '../../utils/types'

export interface NotificationSettings {
  reminderOne: number | undefined
  reminderTwo: number | undefined
  reminderThree: number | undefined
  allowUserInvitationEmail: boolean
}

const initialData: NotificationSettings = {
  reminderOne: 0,
  reminderTwo: 0,
  reminderThree: 0,
  allowUserInvitationEmail: false,
}

export interface NotificationSettingsResponse {
  status: string
  data: NotificationSettings
}

const NotificationSettings: React.FC = () => {
  const getNotificationSettingsData =
    async (): Promise<NotificationSettings> => {
      const response =
        (await getAllNotificationSettings()) as NotificationSettingsResponse
      if (response?.status != 'successful') {
        console.log('error')
        // toast.error('Network Error.', {
        //   position: 'top-right',
        // })
      }
      return response?.data
    }

  const settingsData = useQuery(
    'notificationSettings',
    getNotificationSettingsData
  )
  const [notificationsData, setNotificationsData] =
    useState<NotificationSettings>(initialData)
  const [switchValue, setSwitchValue] = useState<boolean>(false)

  const updateSettings = async (): Promise<void> => {
    try {
      const response = (await UpdateNotificationsSettings(
        notificationsData
      )) as {
        status?: string
        data: NotificationSettings
      }
      if (response?.status === 'successful') {
        toast.success('Notification Settings Updated.', {
          position: 'top-right',
        })
        settingsData.refetch()
      } else {
        toast.error('Password not matched', { position: 'top-right' })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      const errorMessage = errors.response?.data?.message || 'An error occurred'
      toast.error(errorMessage, { position: 'top-right' })
    }
  }

  const handleChange = (
    fieldName: keyof NotificationSettings,
    value: string | boolean | number
  ): void => {
    setNotificationsData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const handleSwitchChange = (value: boolean) => {
    setSwitchValue(value)
    handleChange('allowUserInvitationEmail', value)
  }

  useEffect(() => {
    if (settingsData?.data) {
      setNotificationsData({
        reminderOne: settingsData?.data?.reminderOne,
        reminderTwo: settingsData?.data?.reminderTwo,
        reminderThree: settingsData?.data?.reminderThree,
        allowUserInvitationEmail: settingsData?.data?.allowUserInvitationEmail,
      })
    }

    console.log(
      'this is called',
      settingsData?.data?.allowUserInvitationEmail,
      switchValue
    )
  }, [settingsData?.data])

  return (
    <>
      <div className="flex my-8 gap-2">
        <div className="flex flex-col w-8/12 gap-4">
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              onClick={() => console.log('Accordion')}
              title={'Reminder Emails'}
              isActive={false}
            >
              <div className="flex flex-col gap-4 mt-2 my-4 px-1">
                <div className="w-full p-4 justify-between gap-[10px] bg-white rounded-xl flex">
                  <div className="w-[100%]">
                    <UITextInput
                      onChange={(e) =>
                        handleChange('reminderOne', e.target.value)
                      }
                      type={'number'}
                      value={notificationsData?.reminderOne}
                      placeholder="days"
                      label={'Reminder 1 ( days )'}
                      iconName={''}
                    />
                  </div>
                  <div className="w-[100%]">
                    <UITextInput
                      onChange={(e) =>
                        handleChange('reminderTwo', e.target.value)
                      }
                      value={notificationsData?.reminderTwo}
                      type={'number'}
                      placeholder="days"
                      label={'Reminder 2 ( days )'}
                      iconName={''}
                    />
                  </div>
                  <div className="w-[100%]">
                    <UITextInput
                      onChange={(e) =>
                        handleChange('reminderThree', e.target.value)
                      }
                      value={notificationsData?.reminderThree}
                      placeholder="days"
                      type={'number'}
                      label={'Reminder 3 ( days )'}
                      iconName={''}
                    />
                  </div>
                </div>
                <div className="w-full p-4 bg-gray1 rounded-xl flex">
                  <div className="flex-1">
                    <p className="text-sm font-semibold leading-6 text-text4">
                      Verification Email
                    </p>
                  </div>
                  <div>
                    <UISwitch
                      value={notificationsData?.allowUserInvitationEmail}
                      onValueChange={handleSwitchChange}
                    />
                  </div>
                </div>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <div className="bg-gray3 w-full h-[1px] "></div>
      <div className="w-[33%] mt-6 gap-[20px] flex">
        <UIButton
          label="Update"
          onClick={() => {
            updateSettings()
          }}
        />
      </div>
    </>
  )
}

export default NotificationSettings
